import { FormCheckboxBlock } from "@/blocks/forms/checkbox/component";
import checkboxZodSchema from "@/blocks/forms/checkbox/zod";
import { FormRadioBlock } from "@/blocks/forms/radio/component";
import radioZodSchema from "@/blocks/forms/radio/zod";
import { FormToggleGroupBlock } from "@/blocks/forms/toggle-group/component";
import { FormFileBlock } from "@/blocks/forms/file/component";
import fileZodSchema from "@/blocks/forms/file/zod";
import { FormEmailBlock } from "@/blocks/forms/email/component";
import emailZodSchema from "@/blocks/forms/email/zod";
import { FormNumberBlock } from "@/blocks/forms/number/component";
import numberZodSchema from "@/blocks/forms/number/zod";
import { FormPhoneBlock } from "@/blocks/forms/phone/component";
import phoneZodSchema from "@/blocks/forms/phone/zod";
import { FormRangeSliderBlock } from "@/blocks/forms/range-slider/component";
import rangeSliderZodSchema from "@/blocks/forms/range-slider/zod";
import { FormSearchProfileBlock } from "@/blocks/forms/search-profile/component";
import formSearchProfileZodSchema from "@/blocks/forms/search-profile/zod";
import { FormSelectBlock } from "@/blocks/forms/select/component";
import selectZodSchema from "@/blocks/forms/select/zod";
import { FormDateBlock } from "@/blocks/forms/date/component";
import formDateZodSchema from "@/blocks/forms/date/zod";
import { FormTextBlock } from "@/blocks/forms/text/component";
import formTextZodSchema from "@/blocks/forms/text/zod";
import { FormTextareaBlock } from "@/blocks/forms/textarea/component";
import formTextareaZodSchema from "@/blocks/forms/textarea/zod";

export const formBlockComponents = {
	"form-number": {
		component: FormNumberBlock,
		zodSchema: numberZodSchema,
	},
	"form-phone": {
		component: FormPhoneBlock,
		zodSchema: phoneZodSchema,
	},
	"form-select": {
		component: FormSelectBlock,
		zodSchema: selectZodSchema,
	},
	"form-textarea": {
		component: FormTextareaBlock,
		zodSchema: formTextareaZodSchema,
	},
	"form-text": {
		component: FormTextBlock,
		zodSchema: formTextZodSchema,
	},
	"form-date": {
		component: FormDateBlock,
		zodSchema: formDateZodSchema,
	},
	"form-email": {
		component: FormEmailBlock,
		zodSchema: emailZodSchema,
	},
	"form-checkbox": {
		component: FormCheckboxBlock,
		zodSchema: checkboxZodSchema,
	},
	"form-radio": {
		component: FormRadioBlock,
		zodSchema: radioZodSchema,
	},
	"form-toggle-group": {
		component: FormToggleGroupBlock,
		zodSchema: selectZodSchema,
	},
	"form-range-slider": {
		component: FormRangeSliderBlock,
		zodSchema: rangeSliderZodSchema,
	},
	"form-file": {
		component: FormFileBlock,
		zodSchema: fileZodSchema,
	},
	"form-search-profile": {
		component: FormSearchProfileBlock,
		zodSchema: formSearchProfileZodSchema,
	},
} as const;
